import {createAction} from '@reduxjs/toolkit';

import type {ChannelCategory} from '@mattermost/types/channel_categories';

export const receivedChannelCategory = createAction<ChannelCategory>('sidebar/actions/receivedChannelCategory');
